export const extraTaskConst = {
    Khac: 'Khác'
}